import React from 'react';
export function ForWhomSection() {
  const yesList = ['Riconosci il ciclo Piacere → Colpa → Vuoto nella tua esperienza', 'Hai già provato la forza di volontà e non è stata sufficiente', 'Vuoi strumenti concreti, non altre informazioni sul problema', 'Preferisci lavorarci in privato, senza terapia pubblica né gruppi', 'Sei disposto/a a 5-15 minuti al giorno di pratica reale'];
  const noList = ['Cerchi una soluzione magica senza alcuno sforzo da parte tua', 'Non sei disposto/a a essere onesto/a con te stesso/a nel processo', 'Hai bisogno di assistenza clinica urgente — in quel caso rivolgiti prima a un medico'];
  return <section className="py-6 md:py-8 px-5 bg-[radial-gradient(ellipse_at_right,rgba(194,0,111,0.12)_0%,transparent_60%),var(--dark-bg)]" data-id="element-53" data-mp="t5wc3fojlb70">
      <div className="max-w-[900px] mx-auto" data-id="element-54" data-mp="38vzdbi5i9eqd">
        <span className="inline-block font-heading font-bold text-[0.75rem] tracking-[3px] uppercase text-magenta-bright mb-2" data-id="element-55" data-mp="38z502qqnw4ix">
          È per te?
        </span>
        <h2 className="text-[clamp(1.8rem,4vw,2.8rem)] font-heading font-black leading-[1.2] mb-3" data-id="element-56" data-mp="34stwyk9bvy9v">
          Questo è per te se...
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4" data-id="element-57" data-mp="2zvagret2lbfa">
          {/* Yes Card */}
          <div className="rounded-2xl p-5 bg-[rgba(0,207,255,0.05)] border border-[rgba(0,207,255,0.3)]" data-id="element-58" data-mp="3dqcp08le3cv9">
            <h3 className="text-[1.2rem] font-heading font-bold text-blue-light mb-3" data-id="element-59" data-mp="3nqwqncctmje0">
              ✅ Sì, è per te
            </h3>
            <ul className="list-none space-y-0" data-id="element-60" data-mp="3islf8x6vo0to">
              {yesList.map((item, idx) => <li key={idx} className="flex items-start gap-3 py-2 border-b border-white/5 last:border-b-0 text-[0.95rem] text-white/80 leading-[1.5]" data-id="element-61" data-mp="e2isv47nez0" data-mpi={idx}>
                  <span className="text-[1.1rem] shrink-0 mt-[2px]" data-id="element-62" data-mp="ad1rgdoz7am0">✓</span>
                  <span data-id="element-63" data-mp="5dffe7kvw0es">{item}</span>
                </li>)}
            </ul>
          </div>
          {/* No Card */}
          <div className="rounded-2xl p-5 bg-[rgba(194,0,111,0.05)] border border-[rgba(194,0,111,0.2)]" data-id="element-64" data-mp="2z66np03awk58">
            <h3 className="text-[1.2rem] font-heading font-bold text-magenta-bright mb-3" data-id="element-65" data-mp="3370cdvoki2z6">
              ❌ Non è per te se
            </h3>
            <ul className="list-none space-y-0" data-id="element-66" data-mp="3cwa43afi1jmr">
              {noList.map((item, idx) => <li key={idx} className="flex items-start gap-3 py-2 border-b border-white/5 last:border-b-0 text-[0.95rem] text-white/80 leading-[1.5]" data-id="element-67" data-mp="3cy4o8miy57ps" data-mpi={idx}>
                  <span className="text-[1.1rem] shrink-0 mt-[2px] text-magenta-bright" data-id="element-68" data-mp="3qw1obswlzw97">
                    ✗
                  </span>
                  <span data-id="element-69" data-mp="3vu3a4llf69od">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}